module.exports = __webpack_public_path__ + "img/l.e8e7c871.jpg";